DOMReady( function(){
  [... document.querySelectorAll('a[href*="https://notretemps.alphonse.app/connexion"]')].map( l => {
    const searchParams = new URLSearchParams(window.location.search);
    let link = l.href;
    if(searchParams.has('utm_source'))
    {
      link+='?utm_source='+searchParams.get('utm_source');
    }
    if(searchParams.has('utm_medium'))
    {
      link+='&utm_medium='+searchParams.get('utm_medium');
    }

    if(searchParams.has('utm_campaign'))
    {
      link+='&utm_campaign='+searchParams.get('utm_campaign');
    }

    l.href = link;
  });
});
